module.exports = __webpack_public_path__ + "static/media/rBolb.aec15fbf.png";